import React from 'react';
import type { DecoratorFn } from '@storybook/react';

export const withoutPseudoLocalization = () => {
    const decorator: DecoratorFn = (Story) => (
        <div className="without-pseudo-localization-wrapper">
            <Story />
        </div>
    );

    return decorator;
};
